import { ImageTransformModelId } from '@/types/image'
import { CropperImageTransform } from '../types'

export default function getDefaultCropperImageTransform({
  model_id,
  item_id,
  source = '',
}: {
  model_id?: number
  item_id?: ImageTransformModelId
  source?: string
} = {}): CropperImageTransform {
  return {
    id: 0,
    crop_h: 0,
    crop_w: 0,
    crop_x: 0,
    crop_y: 0,
    image_id: null,
    image: {
      id: 0,
      url: '',
      copyrightImage: {
        url: '',
        source,
        source_url: '',
      },
    },
    model_id,
    item_id,
  }
}
